import { render, staticRenderFns } from "./pieCard.vue?vue&type=template&id=7d38b112&scoped=true"
import script from "./pieCard.vue?vue&type=script&lang=js"
export * from "./pieCard.vue?vue&type=script&lang=js"
import style0 from "./pieCard.vue?vue&type=style&index=0&id=7d38b112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d38b112",
  null
  
)

export default component.exports